/** Rolling transfer rate over the last few seconds, for speed and ETA. */
export class SpeedMeter {
  private samples: Array<{ at: number; bytes: number }> = [];

  constructor(private readonly windowMs = 8000) {}

  add(bytes: number, at = Date.now()): void {
    this.samples.push({ at, bytes });
    const cutoff = at - this.windowMs;
    while (this.samples.length > 2 && (this.samples[0]?.at ?? at) < cutoff) this.samples.shift();
  }

  /** Bytes per second, or null until there's enough data. */
  rate(): number | null {
    const first = this.samples[0];
    const last = this.samples.at(-1);
    if (!first || !last || last.at - first.at < 500) return null;
    return (last.bytes - first.bytes) / ((last.at - first.at) / 1000);
  }

  reset(): void {
    this.samples = [];
  }
}

export function formatRate(bytesPerSecond: number): string {
  const mb = bytesPerSecond / 1_000_000;
  return mb >= 1
    ? `${mb.toFixed(1)} MB/s`
    : `${Math.max(1, Math.round(bytesPerSecond / 1000))} KB/s`;
}

export function formatEta(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return "";
  if (seconds < 60) return "less than a minute left";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min left`;
  const hours = Math.floor(minutes / 60);
  return `${hours} h ${minutes % 60} min left`;
}
